/**
 * Service to handle work order integration strategy
 * Provides functions to open work orders with Expo integration
 */

var app = angular.module('leonardo');

app.factory('WorkOrderProviderService', [
  '$q',
  'ngDialog',
  '$log',
  function($q, ngDialog, $log) {

    var config = {
      allowFallback: true,        // Whether to allow fallback to legacy form if Expo fails
      expoInitTimeout: 10000,     // Maximum time to wait for Expo to initialize (ms)
      enabled: false              // Whether Expo integration is enabled by default
    };

    /**
     * Open using the Expo integration
     */
    function openExpoWorkOrder(options) {
      var dialogOptions = {
        template: 'views/templates/dialog/work-order/expo.html',
        className: 'ngdialog-theme-default ngdialog-work-order ngdialog-work-order-expo',
        controller: 'WorkOrderExpoDialog',
        resolve: {
          workOrderObj: [function() { return options.workOrderObj || null; }]
        },
        data: angular.extend({}, options.data || {}, {
          action: options.action || 'create',
          workOrderId: options.workOrderId || null,
          // Add Expo specific options
          allowFallback: config.allowFallback,
          expoInitTimeout: config.expoInitTimeout,
          // Add a fallback function that will be called by the controller if needed
          fallbackCallback: function() {
            var deferred = $q.defer();
            if (config.allowFallback) {
                ngDialog.close();
                
                // Return rejected promise to notify caller to handle the fallback
                setTimeout(function() {
                var error = new Error('Expo integration failed - component should handle fallback');
                deferred.reject(error);
                }, 300);
            } else {
                deferred.reject(new Error('Fallback to legacy form is not allowed'));
            }
            return deferred.promise;
          }
        })
      };
      
      if (options.closeCallback) {
        return ngDialog.openConfirm(dialogOptions).then(
          function(result) {
            if (options.closeCallback) {
              options.closeCallback(result);
            }
            return result;
          },
          function(error) {
            if (options.closeCallback) {
              options.closeCallback(null);
            }
            return $q.reject(error);
          }
        );
      } else {
        return ngDialog.open(dialogOptions);
      }
    }
    
    /**
     * Open using the legacy AngularJS integration
     */
    function openLegacyWorkOrder(options) {
      var dialogOptions = {
        template: 'views/templates/dialog/work-order/form.html',
        className: 'ngdialog-theme-default ngdialog-template-edit',
        controller: 'WorkOrderDialogForm',
        data: {
          work_order: options.workOrderObj || null,
          task: options.data && options.data.task ? options.data.task : null,
          action: options.action || 'create'
        }
      };
      
      if (options.closeCallback) {
        return ngDialog.openConfirm(dialogOptions).then(
          function(result) {
            if (options.closeCallback) {
              options.closeCallback(result);
            }
            return result;
          },
          function(error) {
            if (options.closeCallback) {
              options.closeCallback(null);
            }
            return $q.reject(error);
          }
        );
      } else {
        return ngDialog.open(dialogOptions);
      }
    }
    
    /**
     * Open a work order
     * @param {Object} options - The options for the work order
     */
    function openWorkOrder(options) {
      if (options.useExpoIntegration) {
        // Try Expo first, fallback to legacy if it fails
        return openExpoWorkOrder(options).catch(function(error) {
          if (error === 'EXPO_INTEGRATION_FAILED' || 
              (error && error.message === 'Expo integration failed - component should handle fallback')) {
            return openLegacyWorkOrder(options);
          }
          return $q.reject(error);
        });
      } else {
        return openLegacyWorkOrder(options);
      }
    }
    
    // Create API object
    var api = {
      /**
       * Open a work order
       * @param {Object} options - The options for the work order
       */
      openWorkOrder: openWorkOrder
    };
  
    return api;
  }
]);